// extracted by mini-css-extract-plugin
module.exports = {"Floater":"Floater_Floater__3J9I7","left":"Floater_left__Uejeb","right":"Floater_right__mCRFz","small":"Floater_small__3tMxW","medium":"Floater_medium__169gD"};